import MoneyField from 'components/MoneyField';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Icon, TooltipHost } from 'office-ui-fabric-react';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import React, { Component, Fragment } from 'react';
import { biddingStepsDefinitions } from './biddingStepsDefinitions';
import IncrementalAuction from './IncrementalAuction';

@inject('app', 'sale')
@observer
class RoundPriceEdit extends Component {
  @computed get isStartingPriceValid() {
    return this.props.store.isStartingPriceValid;
  }

  @computed get startPriceError() {
    const { t, store } = this.props;
    const error = store.startPriceError;
    return error === '' ? error : t(error);
  }

  @computed get biddingSteps() {
    return (startingPrice) => {
      let key = 0;
      Object.keys(biddingStepsDefinitions).forEach((b) => {
        if (b <= startingPrice) {
          key = b;
        }
        if (b > startingPrice) return;
      });

      return biddingStepsDefinitions[key];
    };
  }

  @computed get currentBidStep() {
    const {
      store: { round },
    } = this.props;
    if (!round.biddingSteps) {
      return undefined;
    }
    return round.biddingSteps.replace('0=0;1=', '');
  }

  @computed get selectedStepValue() {
    return (startPrice, useStepDefaultValue) => {
      const step = this.biddingSteps(startPrice);
      const stepValue = this.currentBidStep;
      const result =
        stepValue &&
        step.values.some((v) => {
          return v.toString() === stepValue;
        })
          ? stepValue
          : useStepDefaultValue
          ? step.default.toString()
          : 'default'; //step.default.toString();

      return result;
    };
  }

  handleFieldChanged = (field) => (value) => {
    const {
      store: { round },
    } = this.props;
    round[field] = value;
  };

  handleStartPriceChange = (value) => {
    const {
      store: { round },
    } = this.props;
    round['startPrice'] = value;

    const bid = this.selectedStepValue(value, true);
    round['biddingSteps'] = bid === 'default' ? null : `0=0;1=${bid}`;
  };

  handleBidStepChanged = (option) => {
    const {
      store: { round },
    } = this.props;
    round['biddingSteps'] =
      option.key === 'default' ? null : `0=0;1=${option.key}`;
  };

  render() {
    const {
      t,
      store: { round },
    } = this.props;

    const step = this.biddingSteps(round.startPrice);

    if (round.type === 'incremental_auction') {
      return <IncrementalAuction {...this.props} />;
    }

    return (
      <Fragment>
        {round.type !== 'counteroffer_bidding' && (
          <div>
            <MoneyField
              label={
                round.type === 'open_bidding'
                  ? t('Starting price')
                  : t('Minimum price')
              }
              currency={this.props.app.currency.code}
              locale={this.props.intl.locale}
              value={round.startPrice}
              onChanged={this.handleStartPriceChange}
              tooltip={t('Starting price - tooltip')}
              autoComplete="off"
              errorMessage={
                !this.startPriceError ? undefined : t(this.startPriceError)
              }
            />
          </div>
        )}

        {round.type !== 'open_bidding' && (
          <div>
            <MoneyField
              label={
                round.type === 'counteroffer_bidding'
                  ? t('Counteroffer value')
                  : t('Estimate')
              }
              currency={this.props.app.currency.code}
              locale={this.props.intl.locale}
              value={round.estimate}
              onChanged={this.handleFieldChanged('estimate')}
              tooltip={t('Estimate - tooltip')}
              autoComplete="off"
            />
          </div>
        )}
        {this.props.sale.saleConfig.roundShowRedButtonPrice &&
          round.type !== 'counteroffer_bidding' && (
            <div>
              <MoneyField
                label={t('Red button price')}
                currency={this.props.app.currency.code}
                locale={this.props.intl.locale}
                value={round.redButtonPrice}
                onChanged={this.handleFieldChanged('redButtonPrice')}
                tooltip={t('Red button price - tooltip')}
                autoComplete="off"
              />
            </div>
          )}
        {this.props.sale.saleConfig.roundShowBidSteps &&
          round.type === 'open_bidding' && (
            <div>
              <Dropdown
                onChanged={this.handleBidStepChanged}
                label={
                  <Fragment>
                    {t('Bidding steps')}{' '}
                    <TooltipHost content={t('Bidding steps - tooltip')}>
                      <Icon iconName="Info" />
                    </TooltipHost>
                  </Fragment>
                }
                selectedKey={this.selectedStepValue(round.startPrice)}
                options={[
                  ...(this.props.sale.saleConfig.roundShowDefaultBidSteps
                    ? [{ key: 'default', text: t('Bidding steps - standard') }]
                    : []),
                  ...step.values.map((v) => {
                    const str = v.toString();
                    return {
                      key: str,
                      text: v.toFormattedMoney(
                        this.props.intl.locale,
                        this.props.app.currency.code,
                        0
                      ),
                    };
                  }),
                ]}
              />
            </div>
          )}
      </Fragment>
    );
  }
}

export default RoundPriceEdit;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/RoundSection/RoundPriceEditDefault.jsx